import { render, staticRenderFns } from "./WelcomeNextShipment.vue?vue&type=template&id=41855c51&scoped=true&lang=pug&"
import script from "./WelcomeNextShipment.vue?vue&type=script&lang=js&"
export * from "./WelcomeNextShipment.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeNextShipment.vue?vue&type=style&index=0&id=41855c51&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41855c51",
  null
  
)

export default component.exports